import React from 'react';
import styles from './featured.css';

import { Link } from 'react-router-dom';

function Featured({ data }) {
	const { featured } = data.acf;

	return(
		<div className={styles.content}>
			<section className={styles.grid}>
			{
				featured.map((item, index) =>
					<article
						className={styles.gridItem}
						key={index}>
						<Link
							to={`/work/${item.featured_work.post_name}`}
							className={styles.featuredLink}
							title={item.featured_work.post_title}>
							<span style={{ backgroundColor: item.background_color }} className={styles.bgColor} />
              <span className={styles.imgContainer}>
  							<img
  				      	data-sizes="auto"
  				      	src={item.featured_image.sizes.medium}
  				      	data-srcset={[
  				      		`${item.featured_image.sizes.medium_large} 300w`,
  				      		`${item.featured_image.sizes.large} 600w`,
  				      		`${item.featured_image.url} 900w`
  				      	]}
  				      	className={`${styles.img} lazyload`}
  				     />
             </span>
						</Link>
					</article>
				)
			}
			</section>
		</div>
	);
}

export default Featured;



// WEBPACK FOOTER //
// ./src/components/Featured/Featured.js